/**
 * Company Highlights Configuration
 *
 * Contenido destacado por empresa en "Líderes en IA" (/news/.../:company).
 * Se muestra como un card que ocupa 2 espacios al inicio del grid.
 * La clave es el slug de la empresa (ver topCompanies en TopCompanies.vue).
 *
 * Campos:
 * - type:   'video' | 'image'
 * - src:    URL del video (mp4) o de la imagen
 * - poster: (opcional) imagen de respaldo; en videos también es la vista previa.
 *           Si falla src se muestra el poster; si falla también (o no hay), el card se oculta.
 * - title:  (opcional) texto del pie del card
 * - link:   (opcional) URL a la que lleva el pie del card
 *
 * Para quitar el destacado de una empresa, borra su entrada.
 */

export default {
  openai: {
    type: 'video',
    src: 'https://cdn.openai.com/ctf-cdn/Hero-16x9-No%20Music.mp4',
    poster: 'https://images.ctfassets.net/kftzwdyauwt9/6aziMFlkfqPiaNdkZujHdo/74adba940d8bc2c3d9f7e500c71298ab/astra_16x9_poster.png?w=1200&q=50&fm=webp',
    title: 'GPT 6 Astra',
    link: 'https://openai.com/es-419/index/gpt-6-astra/',
  },
  deepmind: {
    type: 'image',
    src: '',
    poster: 'https://storage.googleapis.com/gweb-uniblog-publish-prod/images/gemini-3-8_flash__blog__header__.width-1600.format-webp.webp',
    title: 'Introducing Gemini 3.8 Flash and 3.8 Flash Cyber',
    link: 'https://blog.google/innovation-and-ai/models-and-research/gemini-models/3-8-flash-and-3-8-flash-cyber/',
  },
  anthropic: {
    type: 'video',
    src: 'https://cdn.sanity.io/files/4zrzovbb/website/aa25c1b532954655ad91dd802e8d82e9579df571.mp4',
    poster: '',
    title: 'claude Opus 5.5',
    link: 'https://www.anthropic.com/claude-opus-5-5',
  }

  // Ejemplo con imagen:
  // nvidia: {
  //   type: 'image',
  //   src: 'https://.../imagen.webp',
  //   title: 'Lo último de Nvidia',
  //   link: 'https://www.nvidia.com/',
  // },
};
